import styles from '../MobileCard.module.scss';

export function Line(): React.ReactElement<any> {
    return <hr className={styles.line} />;
}
